// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleCopy_title__3W9mi multilang-support"};